import {
  fetchClient
} from "./chunk-64N4INLD.mjs";
import {
  __async
} from "./chunk-RGHW4PYM.mjs";

// src/core/wbk/wallet/userWallets.ts
import { Exception } from "@wbk/logger";
import { getLocaleOnly } from "@wbk/utils";
var getUserWallets = (_0) => __async(null, [_0], function* ({ lang }) {
  var _a;
  try {
    const data = yield fetchClient({
      url: `/wallet/user-wallets?lang=${getLocaleOnly(lang)}`
    });
    return ((_a = data.data) == null ? void 0 : _a.wallets) || [];
  } catch (error) {
    throw new Exception({
      error,
      name: "getUserWalletsException",
      context: { level: "warning", extra: { lang } }
    });
  }
});

export {
  getUserWallets
};
//# sourceMappingURL=chunk-DEJ436V5.mjs.map